module.exports = __webpack_public_path__ + "static/media/logo.ef803551.webp";